import { useGetWoocommerceCategoriesQuery } from 'gql/types';
import { useMemo } from 'react';

import { mapWoocommerceCategories } from '../utils/mapWoocommerceCategoryName';

export const useWoocommerceCategories = () => {
  const query = useGetWoocommerceCategoriesQuery({
    variables: { input: {} },
  });

  const categories = useMemo(() => {
    if (!query.data?.getWoocommerceCategories) {
      return undefined;
    }

    return mapWoocommerceCategories(query.data.getWoocommerceCategories);
  }, [query.data]);

  return {
    ...query,
    categories,
  };
};
